import { FC } from "react";
import DynamicCard from "./default";
import { DynamicCardProps } from "./types";

const HaiAnhDynamicCard: FC<DynamicCardProps> = (props) => (
  <DynamicCard {...props} theme="haianh" />
);

HaiAnhDynamicCard.displayName = "HaiAnhDynamicCard";

export default HaiAnhDynamicCard;
